import { excelStore } from "src/stores/excel-store.interface";
import ManualVocWaterTable from "./components/ManualVocWaterTable";
import { useShallow } from "zustand/react/shallow";
import { useEffect } from "react";

const ManualVocWater = () => {
  const currentYear = new Date().getFullYear();
  const setSelectedYearExcel = excelStore(useShallow((state) => state.setSelectedYear));

  useEffect(() => {
    return () => {
      setSelectedYearExcel(currentYear.toString());
    };
  }, []);
  return <ManualVocWaterTable />;
};

export default ManualVocWater;
